import type { ValueConfig } from "@smartsuite/automation-engine-api";
import type { EditorState, ContentItem } from "@smartsuite/smartdoc";
import type {
  ActionCandidate,
  TriggerCandidate,
} from "../../../../../../../../types/candidate";

export const toValueConfig = (
  value: EditorState,
  trigger: TriggerCandidate,
  actions: ActionCandidate[],
): ValueConfig => {
  const json = value.toJSON();

  return {
    values: json.doc.content.flatMap(
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      (item: { [key: string]: any }, index: number) => {
        const values =
          item.content?.reduce((acc: ContentItem[], item: ContentItem) => {
            if (item.type === "hard_break") {
              return [
                ...acc,
                {
                  value: {
                    oneofKind: "string",
                    string: "\n",
                  },
                },
              ];
            } else if (item.type === "text") {
              if (item.text !== undefined) {
                return [
                  ...acc,
                  {
                    value: {
                      oneofKind: "string",
                      string: item.text ?? "",
                    },
                  },
                ];
              }
              return acc;
            } else if (item.type === "pill") {
              const value = JSON.parse(String(item.attrs?.value));
              if (value.target === "team") {
                return [
                  ...acc,
                  {
                    value: {
                      oneofKind: "function",
                      function: {
                        function: {
                          oneofKind: "teamId",
                          teamId: { teamId: value.teamId },
                        },
                      },
                    },
                  },
                ];
              }
              if (value.target === "action") {
                return [
                  ...acc,
                  {
                    value: {
                      oneofKind: "reference",
                      reference: {
                        outputId: String(value.value),
                        source: {
                          oneofKind: "actionReference",
                          actionReference: actions.find(
                            (action) => action.hash === value.hash,
                          ),
                        },
                      },
                    },
                  },
                ];
              }
              if (value.target === "trigger") {
                return [
                  ...acc,
                  {
                    value: {
                      oneofKind: "reference",
                      reference: {
                        outputId: String(value.value),
                        source: {
                          oneofKind: "triggerReference",
                          triggerReference: trigger.triggerReference,
                        },
                      },
                    },
                  },
                ];
              } else {
                // for compatibility with smartdoc pills
                return [
                  ...acc,
                  {
                    value: {
                      oneofKind: "reference",
                      reference: value,
                    },
                  },
                ];
              }
            } else {
              return [...acc, { value: {} }];
            }
          }, []) ?? [];

        if (index !== 0) {
          return [
            {
              value: {
                oneofKind: "string",
                string: "\n",
              },
            },
            ...values,
          ];
        }
        return values;
      },
    ),
  };
};
